<template>
    <AppHeaderDropdown right no-caret>
        <template slot="header">
            <i class="fa fa-spinner fa-spin" v-if="authIsLoading" />
            <b-button :variant="buttonVariant" v-if="!authIsLoading">
                <i class="fa fa-user d-md-none" />
                <span class="d-none d-md-block"
                    >&nbsp;{{ user.name }}</span
                > </b-button
            >&nbsp;
        </template>
        <template slot="dropdown">
            <b-dropdown-item v-if="isImpersonated">
                <b-button variant="primary" @click="endImpersonation()">
                    <i class="fa fa-user d-md-none" />

                    <span class="d-none d-md-block">{{
                        $t('text.Stopimpersonate')
                    }}</span>
                </b-button>
            </b-dropdown-item>

            <b-dropdown-item
                @click="
                    $router.push(
                        '/organization/' + user.company_id + '/users/' + user.id
                    )
                "
            >
                <i class="fa fa-user" />
                {{ $t('label.myProfile') }}
            </b-dropdown-item>

            <b-dropdown-item
                @click="
                    toRoute({ name: 'profile', params: { sub: 'settings' } })
                "
                v-if="false"
            >
                <i class="fa fa-cog" />
                {{ $t('label.settings') }}
            </b-dropdown-item>

            <b-dropdown-item @click="logout">
                <i class="fa fa-lock" />
                <a>{{ $t('label.logout') }}</a>
            </b-dropdown-item>
        </template>
    </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
import { mapActions, mapGetters } from 'vuex'

export default {
    name: 'DefaultHeaderDropdownAccnt',
    components: {
        AppHeaderDropdown,
    },
    data() {
        return {}
    },
    created() {
        // console.log('this.router', this.$router)
    },

    computed: {
        ...mapGetters({
            user: 'auth/user',
            authIsLoading: 'auth/isLoading',
        }),

        isImpersonated() {
            let isImp = this.$store.getters['auth/isImpersonated']
            return isImp
        },
        buttonVariant() {
            if (!this.$store.getters['auth/isImpersonated']) {
                return 'light'
            }
            return 'danger'
        },
    },

    methods: {
        ...mapActions({
            logout: 'auth/logout',
        }),

        toRoute(route) {
            this.$router.push(route)
        },
        endImpersonation() {
            this.$store.dispatch('auth/stopImpersonation')
        },
    },
}
</script>
